import styled from 'styled-components';

export const SectionRegister = styled.div`
  margin: 0 auto;
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-height: 768px) {
      margin-top: 24px;
  }

  p {
    margin-top: 0;
    text-align: center;
    color: #333333;
    font-size: 12px;
    font-weight: 500;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 12px;
    font-weight: 500;
    padding: 6px 12px;
  }
`;

export const Container = styled.div.attrs({
  className: 'content'
})`
  @media only screen and (max-width: 1023px) {
    height: calc(100vh - 500px);
  }

  .login__form {
    height: 100%;
    @media screen and (min-width: 1024px) {
      flex: 1;
    }
    @media only screen and (max-width: 1023px) {
      margin: auto;
      display: flex;
      flex-direction: column;
      width: 84%;
    }
  }

  .login__btn {
    background-color: #CB3D42;
    border-radius: 3px;
    color: #FFFFFF;
    font-weight: 400;
    text-align: center;
    font-family: Montserrat, sans-serif;
    border: 0;
  }

  .login__btn--smaller {
    min-width: 33px;
    width: 10%;
    padding: 9px 0;
    font-size: 10px;
    margin-left: auto;
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.8;
    }
  }
`
